import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { UserService } from '@app/core/services/user.service';
import { LoaderService } from '@app/core/services/loader.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(public auth: UserService, private router: Router, private loaderService: LoaderService, private logger:NGXLogger ) {}

  private handleAuthError(err: HttpErrorResponse): Observable<any> {

      this.loaderService.hide();

      this.logger.debug(err,this.router.url, ' error')
        //handle your auth error or rethrow
        //if (err.status === 401 || err.status === 0|| (err.status === 403 && err.error.message.indexOf('.png') === -1) || (err.error.message && err.error.message.indexOf('connection has been closed') > -1)) {
        if (err.status === 401 || err.status === 0|| (err.error.message && err.error.message.indexOf('connection has been closed') > -1)) {
            //navigate /delete cookies or whatever
            if(this.router.url !== '/logout'){
              this.router.navigateByUrl(`/logout`);
            }else{

            }

            // if you've caught / handled the error, you don't want to rethrow it unless you also want downstream consumers to have to handle it as well.
            return Observable.of(err.message);
        }
        return Observable.throw(err);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    //this.logger.debug(request.url);
      if(request.url.indexOf('uploads') >= 0){
         request = request.clone({
              withCredentials: false
         });
      }else{
        request = request.clone({
             withCredentials: true
        });
      }

      // show the loader service
      this.loaderService.show();

      // intercept the response and set the loader service
      //return next.handle(request).catch(x=> this.handleAuthError(x));

      return next.handle(request).map(event => {

        if (event instanceof HttpResponse) {
           this.loaderService.hide();
        }
        return event;
      }).catch(x=> this.handleAuthError(x));

/*
      return next.handle(request).map(event => {
        if (event instanceof HttpResponse) {
          this.loaderService.hide();
        }
        return event;
      }).catch(x=> this.handleAuthError(x));
      */
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/token.interceptor.ts